import "cross-fetch/polyfill";
import "core-js/stable";
import "regenerator-runtime/runtime";
import { AppContainer } from "react-hot-loader";
import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "src/serviceWorker";
import "./index.css";
import "../src/assets/css/index.css";

import configureStore from "src/store/configureStore";

import Root from "./Root";

const { store, persistor } = configureStore();

declare const module: {
  hot?: {
    accept: (...args: any[]) => void;
    dispose?: (...args: any[]) => void;
  };
};

const render = module.hot ? ReactDOM.render : ReactDOM.hydrate;

const go = () => {
  render(
    <AppContainer>
      <Root store={store} persistor={persistor} />
    </AppContainer>,
    document.getElementById("root")
  );
};

go();

// Hot reloading
if (module.hot) {
  // Reload components
  module.hot.accept("./Root", () => {
    go();
  });
}

serviceWorker.unregister();
